'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/querystring/index.js
 ** module id = 1303
 ** module chunks = 0
 **/